const actionTypes = {
  ON_LOADING: 'ON_LOADING',
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  CHANGE_BOARD_SCREEN: 'CHANGE_BOARD_SCREEN',
  LOAD_RETROSPECTIVE: 'LOAD_RETROSPECTIVE',
  UPDATE_CARDS: 'UPDATE_CARDS',
  UPDATE_MOODS: 'UPDATE_MOODS',
  LOAD_USER: 'LOAD_USER',
  REORDER_CARDS: 'REORDER_CARDS',
  MOVE_AND_UPDATE_CARDS: 'MOVE_AND_UPDATE_CARDS',
  COMBINE_CARDS: 'COMBINE_CARDS',
};

export default actionTypes;
